module.exports = __webpack_public_path__ + "media/fonts/Oricons-2d239e2c6e75b02fb7695b49bcdbd8ff.woff";